import { render, staticRenderFns } from "./worksheet-facade.vue?vue&type=template&id=08a4ed5e&scoped=true&"
import script from "./worksheet-facade.vue?vue&type=script&lang=js&"
export * from "./worksheet-facade.vue?vue&type=script&lang=js&"
import style0 from "./worksheet-facade.vue?vue&type=style&index=0&id=08a4ed5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a4ed5e",
  null
  
)

export default component.exports